(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('accordion-custom[data-hide-when-empty]').forEach(function (accordion) {
      const content = accordion.querySelector('.details-content');
      if (content && content.innerHTML.trim() === '') {
        accordion.style.display = 'none';
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    function ccIsVariantInStock(variant) {
  if (variant.inventoryManaged === '' || variant.inventoryManaged === null) return true;
  return variant.inventoryQuantity > 0;
}

// A variant "matches" a selection where selection entries can be null (wildcard,
// meaning "this option hasn't been explicitly locked by the user yet").
function ccMatchesSelection(variant, selection) {
  return variant.options.every(function (opt, i) {
    return selection[i] === null || selection[i] === undefined || opt === selection[i];
  });
}

function ccFindVariant(variants, selection) {
  return variants.find(function (v) {
    return v.options.every(function (opt, i) {
      return opt === selection[i];
    });
  });
}

// Only groups the shopper has explicitly clicked are "locked" constraints.
// Groups that are still on their default/auto-picked value are wildcards when
// checking whether OTHER buttons are reachable.
function ccGetLockedSelection(picker) {
  const locked = [];
  picker.querySelectorAll('.cc-option-group').forEach(function (g, i) {
    const isLocked = g.dataset.userSelected === 'true';
    const activeBtn = g.querySelector('.cc-option-btn.is-active');
    locked[i] = isLocked && activeBtn ? activeBtn.dataset.value : null;
  });
  return locked;
}

function ccGetFullSelection(picker) {
  const selected = [];
  picker.querySelectorAll('.cc-option-group').forEach(function (g) {
    const activeBtn = g.querySelector('.cc-option-btn.is-active');
    selected.push(activeBtn ? activeBtn.dataset.value : null);
  });
  return selected;
}

// On first render, the Liquid template just marks the FIRST value of every
// option as active — that combination may not correspond to a real, in-stock
// variant. Resolve it to a genuine variant before doing anything else.
function ccResolveInitialSelection(picker, variants) {
  const groups = picker.querySelectorAll('.cc-option-group');
  const defaultSelection = ccGetFullSelection(picker);

  const defaultMatch = ccFindVariant(variants, defaultSelection);
  if (defaultMatch && ccIsVariantInStock(defaultMatch)) return;

  const firstInStock = variants.find(ccIsVariantInStock) || variants[0];
  if (!firstInStock) return;

  groups.forEach(function (group, i) {
    const wantedValue = firstInStock.options[i];
    group.querySelectorAll('.cc-option-btn').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.value === wantedValue);
    });
  });
}

function ccRefreshAvailability(picker) {
  const variants = JSON.parse(picker.querySelector('.cc-variant-data').textContent);
  const groups = picker.querySelectorAll('.cc-option-group');
  const lockedSelection = ccGetLockedSelection(picker);

  // Step 1: mark each button available/unavailable relative only to the
  // user's LOCKED picks (not the auto-selected ones), so an unrelated
  // auto-picked value in another group can't hide a real, valid combination.
  groups.forEach(function (group) {
    const optionIndex = Number(group.dataset.optionIndex);

    group.querySelectorAll('.cc-option-btn').forEach(function (btn) {
      const hypothetical = lockedSelection.slice();
      hypothetical[optionIndex] = btn.dataset.value;

      const existsAndInStock = variants.some(function (v) {
        return ccMatchesSelection(v, hypothetical) && ccIsVariantInStock(v);
      });

      btn.classList.toggle('cc-option-btn--unavailable', !existsAndInStock);
      btn.disabled = !existsAndInStock;
      btn.setAttribute('aria-disabled', String(!existsAndInStock));
      if (!existsAndInStock) {
        btn.title = btn.dataset.value + ' - Unavailable';
      } else {
        btn.removeAttribute('title');
      }
    });
  });

  // Step 2: for groups the user hasn't explicitly locked, make sure the
  // active value is actually available; if not, cascade to the first
  // available value in that group.
  groups.forEach(function (group) {
    const isLocked = group.dataset.userSelected === 'true';
    if (isLocked) return;

    const activeBtn = group.querySelector('.cc-option-btn.is-active');
    const activeIsAvailable = activeBtn && !activeBtn.classList.contains('cc-option-btn--unavailable');
    if (activeIsAvailable) return;

    const firstAvailable = Array.from(group.querySelectorAll('.cc-option-btn')).find(function (b) {
      return !b.classList.contains('cc-option-btn--unavailable');
    });
    if (firstAvailable) {
      group.querySelectorAll('.cc-option-btn').forEach(function (b) {
        b.classList.remove('is-active');
      });
      firstAvailable.classList.add('is-active');
    }
  });

  // Step 3: resolve the final full selection (locked + auto-picked) to a
  // concrete variant and update price / stock badge / add-to-cart, etc.
  const fullSelection = ccGetFullSelection(picker);
  const match = ccFindVariant(variants, fullSelection);
  if (!match) return;

  const inStock = ccIsVariantInStock(match);

  const statusEl = picker.querySelector('[data-stock-status]');
  if (statusEl) {
    statusEl.classList.toggle('is-in-stock', inStock);
    statusEl.classList.toggle('is-out-of-stock', !inStock);
    statusEl.querySelector('.cc-stock-text').textContent = inStock ? 'In stock' : 'Out of stock';
  }

  const card =
    picker.closest('product-card') ||
    picker.closest('[data-product-card]') ||
    picker.closest('li, .grid__item');
  if (!card) return;

  const priceEl = card.querySelector('.price, sale-price, [data-price]');
  if (priceEl) priceEl.textContent = match.price;

  const linkEl = card.querySelector('a[href*="/products/"]');
  if (linkEl) linkEl.href = linkEl.href.split('?')[0] + '?variant=' + match.id;

  if (match.image) {
    const imgEl = card.querySelector('.card__media img, .product-card__figure img, a[href*="/products/"] img');
    if (imgEl) {
      imgEl.removeAttribute('srcset');
      imgEl.removeAttribute('sizes');
      imgEl.src = match.image;
    }
  }

  const addBtn = card.querySelector('[data-add-to-cart], button[name="add"]');
  if (addBtn) addBtn.disabled = !inStock;
}

document.querySelectorAll('.cc-variant-picker').forEach(function (picker) {
  const variants = JSON.parse(picker.querySelector('.cc-variant-data').textContent);
  ccResolveInitialSelection(picker, variants);
  ccRefreshAvailability(picker);
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.cc-option-btn');
  if (!btn) return;
  if (btn.disabled || btn.classList.contains('cc-option-btn--unavailable')) return;

  const picker = btn.closest('.cc-variant-picker');
  const group = btn.closest('.cc-option-group');

  group.querySelectorAll('.cc-option-btn').forEach(function (b) {
    b.classList.remove('is-active');
  });
  btn.classList.add('is-active');

  // This option is now explicitly chosen by the shopper — lock it so it
  // constrains the other (still-automatic) option groups going forward.
  group.dataset.userSelected = 'true';

  ccRefreshAvailability(picker);
});
  } catch(e) { console.error(e); }
})();

})();
